import gql from 'graphql-tag';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';
import { clients } from '../../../util/clients';

const { backend } = clients.direct;

const defaultTransactionFileds = {
  _id: '',
  commentCode: '',
  comment: '',
  description: '',
};

export const commentTypes = {
  namespaced: true,
  state: () => ({
    selectedItems: [],
  }),
  mutations: {},
  actions: {
    async loadCommentTypes({ commit, dispatch }, { criteria, postProcessTrans, baseCrudKey }) {
      let results;
      const gqlfields = defaultTransactionFileds;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
          query taxCommentTypesTrans($criteria:taxCommentsTypesCriteriaType){
            taxCommentTypesTrans(criteria: $criteria) {
                ${fieldsToGqlString(gqlfields)}
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const { taxCommentTypesTrans } = results.data;
        const processedTransData = postProcessTrans
          ? postProcessTrans(taxCommentTypesTrans) : taxCommentTypesTrans;
        commit('base/crud/setItems', [baseCrudKey, processedTransData], {
          root: true,
        });
        return taxCommentTypesTrans;
      } catch (error) {
        dispatch('flashError', 'There was a problem getting Tax Comments Types.', { root: true });
      }
      return [];
    },
    async upsertTaxCommentTypes({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`
          mutation upsertTaxCommentTypes($item:taxCommentTypesInputType!){
            upsertTaxCommentTypes(upsert: $item) {
                ${fieldsToGqlString(defaultTransactionFileds)}
              }
            }
          `,
          variables: {
            item,
          },
          fetchPolicy: 'no-cache',
        });

        clients.handleGQLErrors(results, commit);
        const taxCommentTypesStateData = rootGetters['base/crud/items'](baseCrudKey);
        const newTaxCommentType = results.data.upsertTaxCommentTypes;
        const newList = mergeByIdNewAtTop(taxCommentTypesStateData || [], newTaxCommentType);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (error) {
        dispatch('flashError', 'There was a problem while upsert Tax Comments Types!', { root: true });
      }
    },
  },
};

export default commentTypes;
